var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWaterWhite = function SvgWaterWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M7.743 1.5h6.097m-1.355 3.387h3.387a4.07 4.07 0 0 1 4.064 4.065v2.032h-4.064V9.676c0-.772-.583-1.402-1.355-1.402H3.001m0-3.387h6.097m3.387.678v-.34a1.694 1.694 0 0 0-3.387 0v.34M19.273 17.23c.474.514 1.34 1.476 1.34 2.56 0 1.552-1.212 2.71-2.709 2.71s-2.71-1.158-2.71-2.71c0-1.043.807-1.964 1.362-2.567l1.348-1.497z"
  })));
};
export default SvgWaterWhite;